import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

export const LayerNameText = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
  ellipsis: true,
})`
  flex: 1;
  margin-right: 8px;
  min-width: 0;
`;

export const RegularCheckboxWrapper = styled(Box).attrs({
  padding: '0px 9px', // 1px for border match
  bg: 'background',
})`
  &:hover {
    background: ${({ theme }) => theme.colors.foreground};
  }
`;
